import * as React from 'react';
import { ScreeningToolType } from '../types/ScreeningTool';
import { APIContext } from './ScreeningToolResponse'
import { ScreeningToolQuestionType } from '../types/ScreeningToolQuestion';
import { ScreeningToolQuestionAnswerOptionType } from '../types/ScreeningToolQuestionAnswerOption';
import { ScreeningToolResponseAnswerCreateType } from '../types/ScreeningToolResponseAnswer';
import Intro from './Intro';
import Questions from './Questions';
import { set } from 'react-hook-form';

type QuestionWithOptions = ScreeningToolQuestionType & { answer_options: ScreeningToolQuestionAnswerOptionType[] };

const ScreeningToolQuestions: React.FC<{ screeningTool: ScreeningToolType & { questions: QuestionWithOptions[] }, loading: boolean }> = ({ screeningTool, loading }) => {
  const api = React.useContext(APIContext);
  const questions = screeningTool.questions || [];
  const [currentIdx, setCurrentIdx] = React.useState(0);
  const [selectedOptionId, setSelectedOptionId] = React.useState<number | null>(null);
  const [answers, setAnswers] = React.useState<{ questionId: number; answerOptionId: number }[]>([]);
  const [showIntro, setShowIntro] = React.useState(true);

  const currentQuestion = questions[currentIdx];

  React.useEffect(() => {
    // Pre-select answer if already answered when going back
    const prevAnswer = answers.find(a => a.questionId === currentQuestion?.id);
    setSelectedOptionId(prevAnswer ? prevAnswer.answerOptionId : null);
  }, [currentIdx]);

  const handleOptionSelection = (selectedId: number) => {
    if (selectedId == null) return;
    // Update answers state with the selected option
    setAnswers(prev => {
      // Replace answer if already exists for this question
      const filtered = prev.filter(a => a.questionId !== currentQuestion.id);
      return [...filtered, { questionId: currentQuestion.id, answerOptionId: selectedId }];
    });

    setSelectedOptionId(selectedId);
  };

  const handleNext = () => {
    setSelectedOptionId(null); // Reset selection for next question
    if (currentIdx < questions.length - 1) {
      setCurrentIdx(idx => idx + 1);
    }
  };

  const handleBack = () => {
    if (currentIdx === 0) return;
    setCurrentIdx(idx => idx - 1);
  };

  const handleSubmit = () => {
    const responseAnswers = answers.map(answer => ({
      screening_tool_question_answer_option_id: answer.answerOptionId,
    }));
    api.setScreeningToolResponseAnswers(responseAnswers as ScreeningToolResponseAnswerCreateType[]);
  };

  return (
    <>
      <Intro
        screeningTool={screeningTool}
        onStart={() => setShowIntro(false)}
        show={showIntro}
      />
      <Questions
        questions={questions}
        currentIdx={currentIdx}
        selectedOptionId={selectedOptionId}
        handleSubmit={handleSubmit}
        handleBack={handleBack}
        handleNext={handleNext}
        handleOptionSelection={handleOptionSelection}
        loading={loading}
        show={showIntro}
      />
    </>
  );
};

export default ScreeningToolQuestions;
